import { useTranslation } from 'react-i18next';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

import { UnreadDot } from './unread-dot';

/** "What's new" entry for the AppNav dropdown; the parent owns the dialog. */
export function WhatsNewMenuItem({ unread, onSelect }: { unread: boolean; onSelect: () => void }) {
    const { t } = useTranslation();
    return (
        <DropdownMenuItem onSelect={onSelect}>
            {t('whatsNew.title')}
            {unread && (
                <>
                    <span className="sr-only">{t('whatsNew.unreadHint')}</span>
                    <UnreadDot className="ml-auto" />
                </>
            )}
        </DropdownMenuItem>
    );
}
